/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type NetworkDirectConnectionsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type NetworkDirectConnectionsQuery = {
  __typename?: 'Query';
  networkDirectConnections?: {
    __typename?: 'DirectConnectionsCollection';
    collection?: Array<{
      __typename?: 'DirectConection';
      xingId?: {
        __typename?: 'XingId';
        id: string;
        isHiring?: boolean | null;
        pageName: string;
        displayName: string;
        profileImage?: Array<{
          __typename?: 'ProfileImage';
          url: string;
        } | null> | null;
        occupations?: Array<{
          __typename?: 'XingIdOccupation';
          headline: string;
          subline: string;
        } | null> | null;
      } | null;
      recruiterInsights?: {
        __typename?: 'NetworkRecruiterInsights';
        localizationKey: string;
      } | null;
    } | null> | null;
  } | null;
};

export const NetworkDirectConnectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'networkDirectConnections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'networkDirectConnections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'xingId' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isHiring' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pageName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profileImage' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: {
                                    kind: 'EnumValue',
                                    value: 'SQUARE_256',
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'occupations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headline' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subline' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recruiterInsights' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'localizationKey' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NetworkDirectConnectionsQuery,
  NetworkDirectConnectionsQueryVariables
>;
